import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ESignService } from 'src/app/services/e-sign.service'; // Import ESignService

@Component({
    selector: 'app-sign-failed',
    templateUrl: './sign-failed.component.html',
    styleUrls: ['./sign-failed.component.scss'],
    standalone: false
})
export class SignFailedComponent implements OnInit {
  sign_failure_reason: string;

  private reasonMap: { [key: string]: string } = {
  aadhaarNameMismatch: 'Signatory Name mismatched with Aadhaar Name',
  // add more mappings here...
};

  constructor(private spinner: NgxSpinnerService) {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const reasonKey = urlSearchParams.get('reason');

    this.sign_failure_reason = reasonKey && this.reasonMap[reasonKey]
    ? this.reasonMap[reasonKey] : '';
  }


  ngOnInit(): void {
    this.spinner.hide();
  }

  private handleFallback() {
    // Fallback behavior: close the window
    window.close();
  }

}
